// Warehouse location = Aisle-Bay-Level ("11-2-2"). Typed as digits: last = level, before it = bay, the rest = aisle (1122 → 11-2-2).
export const LOC = { aisle: [1, 11], bay: [1, 8], level: [1, 7] };
const inRange = (n, [lo, hi]) => Number.isInteger(n) && n >= lo && n <= hi;

export function parseLocation(raw) {
  const s = String(raw || "").trim();
  if (!s) return { ok: false, error: "" };
  let parts;
  if (/^\d+-\d+-\d+$/.test(s)) parts = s.split("-").map(Number);
  else if (/^\d{3,4}$/.test(s)) parts = [Number(s.slice(0, -2)), Number(s.slice(-2, -1)), Number(s.slice(-1))];
  else return { ok: false, error: "Type aisle, bay, level as digits (1122) or with dashes (11-2-2)" };
  const [aisle, bay, level] = parts;
  if (!inRange(aisle, LOC.aisle)) return { ok: false, error: `Aisle must be ${LOC.aisle[0]}–${LOC.aisle[1]}` };
  if (!inRange(bay, LOC.bay)) return { ok: false, error: `Bay must be ${LOC.bay[0]}–${LOC.bay[1]}` };
  if (!inRange(level, LOC.level)) return { ok: false, error: `Level must be ${LOC.level[0]}–${LOC.level[1]}` };
  return { ok: true, aisle, bay, level, code: `${aisle}-${bay}-${level}` };
}
